import { render, staticRenderFns } from "./PublicNotifications.vue?vue&type=template&id=5d9854e6&scoped=true"
import script from "./PublicNotifications.vue?vue&type=script&lang=js"
export * from "./PublicNotifications.vue?vue&type=script&lang=js"
import style0 from "./PublicNotifications.vue?vue&type=style&index=0&id=5d9854e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9854e6",
  null
  
)

export default component.exports